import api from "../apis/api";

class RecordingService {
    startRecordingService() {
        return api.recording.startRecording();
    }

    stopRecordingService() {
        return api.recording.stopRecording();
    }

    handleRoomAlertAPI(msg) {
        return api.recording.handleRoomAlertAPI(msg);
    }
}
export default new RecordingService();
